// import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Code from "./pages/Code";
import CodeResult from "./pages/CodeResult";
import Aboutus from "./pages/Aboutus";
import Profile from "./pages/Profile";
import Wishlist from "./pages/Wishlist";
import Terms from "./pages/Terms";
import MyAddressed from "./pages/MyAddressed";
import TrackOrder from "./pages/TrackOrder";
import MyOrders from "./pages/MyOrders";
import ProductsList from "./pages/ProductsList";
import Contactus from "./pages/Contactus";
import ProductDetails from "./pages/ProductDetails";
import Cart from "./pages/Cart";
import Cupons from "./pages/Cupons";
import Checkout from "./pages/Checkout";
import ResetPassword from "./pages/ResetPassword";
import ForgetPassword from "./pages/ForgetPassword";
import Signup from "./pages/Signup";
import OrderDetails from "./pages/OrderDetails";
import Exchange from "./pages/Exchange";
import Privacy from "./pages/Privacy";
import Shipping from "./pages/Shipping";

function MainRoute() {

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/Product/Verify" element={<Code />} />
      <Route path="/Product/Verify/result/:code" element={<CodeResult />} />
      <Route path="/aboutus" element={<Aboutus />} />
      <Route path="/wishlist" element={<Wishlist />} />
      <Route path={"/account_setting"} element={<Profile />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/shipping" element={<Shipping />} />
      <Route path={"/user/addressbook"} element={<MyAddressed />} />
      <Route path="/user/track_order" element={<TrackOrder />} />
      <Route path={"/user/orders"} element={<MyOrders />} />
      <Route path={"/exchange"} element={<Exchange />} />
      <Route path={"/privacy"} element={<Privacy />} />
      <Route path="/collections" element={<ProductsList />} />
      <Route path="/collections/:id" element={<ProductsList />} />
      <Route path="/products" element={<ProductsList />} />
      <Route path="/Contact" element={<Contactus />} />
      <Route path="/product/:id" element={<ProductDetails />} />
      <Route path="/cart" element={<Cart />} />
      <Route path="/user/coupon" element={<Cupons />} />

      <Route path={"/checkout"} element={<Checkout />} />
      <Route path="/forgetPassword" element={<ForgetPassword />} />
            <Route path="/reset-password/:id" element={<ResetPassword />} />
      <Route path="/signup" element={<Signup />} />
      <Route path={"/order/:id"} element={<OrderDetails />} />



    </Routes>


  )
}

export default MainRoute
